import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { Component, Inject, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'
// TODO:Spartacus - // TODO:Spartacus - Class ModalService has been removed and is no longer part of the public API. Use 'LaunchDialogService' instead. For more information, see the 5.0 migration guide.
import { ICON_TYPE } from '@spartacus/storefront'
import { SharedService } from '../../../../services/shared/shared.service'
// ModalService

@Component({
    selector: 'app-short-oversupplied-modal',
    templateUrl: './short-oversupplied-modal.component.html',
    styleUrls: ['./short-oversupplied-modal.component.scss'],
    standalone: false
})
export class ShortOversuppliedModalComponent implements OnInit {
  public iconTypes = ICON_TYPE
  public shortAndOverSuppliedForm: FormGroup
  changeclaims: boolean = false
  public stockCollected = true
  constructor(
    @Inject(DIALOG_DATA) public data: any,
    private dialogRef: DialogRef<ShortOversuppliedModalComponent>,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {}
  changeclaim(e) {
    /* this.sharedService.setDialogData(e.target.value)*/
    this.changeclaims = e.target.value

    this.dialogRef.close({ data: this.changeclaims } as any)
  }
  closeModal() {
    this.dialogRef.close({ data: 'close' } as any)
  }
}
